import React from 'react';
import { observer } from 'mobx-react-lite';

const TipsMcp = observer(({ className }) => {
  return null
  return (
    <div
      className={[
        'flex-shrink-0 w-40px h-18px text-12px text-[#0058FF] font-bold vh-center bg-[#0058FF1A] ml-4px rounded-4px',
        className,
      ]}
    >
      MCP
    </div>
  );
});

export default TipsMcp;
